// Cookiefreies First-Party-Tracking: nur anonyme Event-Zaehler
// (Seitenaufruf + Klick auf Element mit data-testid). Keine Cookies,
// keine IPs, kein Fingerprinting, keine Drittanbieter.
export function trackEvent(target, type = "click") {
  try {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/analytics/event`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ type, target, path: window.location.pathname }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    // Tracking darf niemals die Seite beeinflussen
  }
}
